// extracted by mini-css-extract-plugin
export default {"back-button":"style_back-button__qe5Y1","back-button-disabled":"style_back-button-disabled__Kgkzl"};